import React from 'react'
import PropTypes from 'prop-types'
import {
  CardContainer,
  Icon,
  CardContent,
  CardTitle,
  FeatureCardText,
} from './style'

const FeatureCard = ({ icon, title, text }) => {
  return (
    <CardContainer>
      <Icon src={icon} alt={`icon for ${title}`}></Icon>
      <CardContent>
        {title && <CardTitle>{title}</CardTitle>}
        <FeatureCardText>{text}</FeatureCardText>
      </CardContent>
    </CardContainer>
  )
}

FeatureCard.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.node,
}

export default FeatureCard
